import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { AgGridService } from '../ag-grid.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-input-datepicker-renderer',
  templateUrl: './input-datepicker-renderer.component.html',
  styleUrls: ['./input-datepicker-renderer.component.scss'],
  providers:[DatePipe]
})
export class InputDatepickerRendererComponent implements ICellRendererAngularComp {
  @Input()inputDate: string;
  @Input()isOnlyDateTime: boolean = true;

  params: any;
  minDate: string; // Set your min date here
  maxDate: string; // Set your max date here
  datePattern: RegExp = /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-(19[1-9][0-9]|20[0-9]{2})$/;
  @Output() dateChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor( public agGridService:AgGridService ,public datePipe : DatePipe){
    this.minDate = '1900-01-01';
    this.maxDate = '2050-12-31'; 
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.intialDateApply();
  }

  intialDateApply(){
    this.inputDate = this.datePipe?.transform(this.inputDate, 'yyyy-MM-dd')
  }

  ngOnInit(): void {
   this.getCurrentDate();
  }

  agInit(params: any): void {
    this.params = params;
    const dt = this.datePipe?.transform(params.value, 'yyyy-MM-dd')
    this.inputDate = dt;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.inputDate = params.value;
    return true;
  }

  getValue(): any {
    return this.inputDate;
  }

  isValidDate(dateValue: string): boolean {
    return this.datePattern.test(dateValue);
  }

  isDatepickerChangeByType: boolean = false;

  onkeyDown(event) {
    this.isDatepickerChangeByType = true;
    if(event.key =='Enter'){
      this.setDatepickerValue(event)
    }
    
  }

  onChange(event) {
    if(!this.isDatepickerChangeByType){
      this.setDatepickerValue(event)
    }
    this.isDatepickerChangeByType = false;
  };

  onBlur(event){
    this.setDatepickerValue(event)
  }

  setDatepickerValue(event, inputDate?){
    const date = event?.target?.value??inputDate;
    if(this.params){
        this.params?.node?.setDataValue(this.params?.colDef?.field, date);
        this.agGridService?.onChangeSelectedDates(date, this.params);
      
    } else{
      if(!this.isOnlyDateTime){
        this.dateChanged.emit(date);
      }else{
        const dt =  this.datePipe?.transform(date, 'yyyy-MM-ddTHH:mm:ss');
        this.dateChanged.emit(dt);
      }
    }   
  }

  getCurrentDate(){
    if (!this.inputDate) {
      const today = new Date();
      this.inputDate = this.datePipe?.transform(today, 'yyyy-MM-dd');
      this.setDatepickerValue(null, this.inputDate)
     }
  }

  getupdateCurrentDate(){
      const today = new Date();
      this.inputDate = this.datePipe?.transform(today, 'yyyy-MM-dd');
      this.setDatepickerValue(null, this.inputDate)
  }
  
}